import React, { useEffect, useState } from "react";
import { Loader2, Mail, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/apiClient";
import StatusBadge from "../StatusBadge";

export default function ContactMessages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/contact-messages").then((r) => setItems(r.data.messages)).catch(() => toast.error("Could not load messages")).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.post(`/admin/contact-messages/${id}/status`, { status }); toast.success(`Marked ${status}`); load(); }
    catch { toast.error("Failed"); }
  };

  if (loading) return <div className="flex justify-center p-10"><Loader2 className="h-6 w-6 animate-spin text-emerald-400" /></div>;

  return (
    <div className="space-y-4" data-testid="admin-contact-messages">
      {items.length === 0 && <div className="ledger-card rounded-2xl p-8 text-center text-slate-500">No messages yet.</div>}
      {items.map((m) => (
        <div key={m.message_id} data-testid={`contact-msg-${m.message_id}`} className="ledger-card rounded-2xl p-5">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-heading text-lg font-bold">{m.subject}</p>
              <p className="mt-0.5 text-sm text-slate-300">{m.name} · <span className="font-mono">{m.mobile}</span>{m.email ? ` · ${m.email}` : ""}</p>
              <p className="mt-0.5 font-mono text-[11px] text-slate-500">{new Date(m.created_at).toLocaleString("en-IN")}</p>
            </div>
            <StatusBadge status={m.status} />
          </div>
          <p className="mt-3 whitespace-pre-line text-sm leading-relaxed text-slate-300">{m.message}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {m.email && <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject)}`} className="inline-flex items-center gap-2 rounded-full border border-emerald-500/40 px-4 py-1.5 text-xs text-emerald-300 hover:bg-emerald-500/10"><Mail className="h-3.5 w-3.5" /> Reply by email</a>}
            {m.status !== "READ" && <button data-testid={`contact-msg-read-${m.message_id}`} onClick={() => setStatus(m.message_id, "READ")} className="inline-flex items-center gap-2 rounded-full border border-slate-700 px-4 py-1.5 text-xs text-slate-300 hover:border-slate-500">Mark read</button>}
            {m.status !== "RESOLVED" && <button data-testid={`contact-msg-resolve-${m.message_id}`} onClick={() => setStatus(m.message_id, "RESOLVED")} className="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-4 py-1.5 text-xs font-semibold text-slate-950 hover:bg-emerald-400"><Check className="h-3.5 w-3.5" /> Resolve</button>}
          </div>
        </div>
      ))}
    </div>
  );
}
